// checkPermission.js
import { selectCheckPermission } from './locations';
import AppState from '../types/AppState';

const mapStateToProps = (state: AppState) => ({
  resultFunc: selectCheckPermission(state),
});

const checkPermission = (permissionKey) => (dispatch, getState) => {
  const { resultFunc } = mapStateToProps(getState());
  return resultFunc(permissionKey);
};

export { checkPermission };
